export default {
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
    updateOrder(state, payload) {
        state.Order = payload;
    },
    updateOrders(state, payload) {
        state.Orders = payload;
    }
}